const initializedOverlays = new WeakSet();
const hiddenClass = 'is-footer-nav-passed';

const getFloatingWhatsappOverlays = (scope) => {
  if (scope.matches?.('.floating-whatsapp-overlay')) {
    return [scope];
  }

  return scope.querySelectorAll?.('.floating-whatsapp-overlay') || [];
};

const initFloatingWhatsapp = (scope = document) => {
  const overlays = getFloatingWhatsappOverlays(scope);

  overlays.forEach((overlay) => {
    if (initializedOverlays.has(overlay)) {
      return;
    }

    const button = overlay.querySelector('.floating-whatsapp');
    const footerNav = document.querySelector('.footer__nav');

    if (!button || !footerNav) {
      return;
    }

    initializedOverlays.add(overlay);

    let updateFrame = null;

    const updateState = () => {
      const footerNavRect = footerNav.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();
      const shouldHide = footerNavRect.bottom <= buttonRect.top;

      overlay.classList.toggle(hiddenClass, shouldHide);
    };

    const requestUpdate = () => {
      if (updateFrame) {
        return;
      }

      updateFrame = requestAnimationFrame(() => {
        updateFrame = null;
        updateState();
      });
    };

    requestUpdate();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    window.addEventListener('orientationchange', requestUpdate, { passive: true });
    window.addEventListener('load', requestUpdate, { once: true });
  });
};

initFloatingWhatsapp();
window.initFloatingWhatsapp = initFloatingWhatsapp;
